import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS} from '../../constants';

import {ClosedLeadDripSequenceStartTriggersContainer} from '../card-containers/closed-lead-drip-sequence-start-triggers-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function ClosedLeadDripSequenceStartTrigger(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}>
                {['LEAD_WON', 'LEAD_LOST', 'LEAD_CANCELLED'].map((outcomeType) => (
                    <ClosedLeadDripSequenceStartTriggersContainer
                        key={outcomeType}
                        // @ts-expect-error
                        outcomeType={outcomeType}
                        isLoading={props.isLoading}
                        errorMessage={props.errorMessage}
                        closedLeadAutomations={props.closedLeadAutomations}
                    />
                ))}
            </CollapsibleSection>
        </DragDropContext>
    );
}
